/**
 * Created by zengjie on 2017/1/10.
 */
const hasClass = function (target, name) {
  let className = target.getAttribute('class')
  if (!className) {
    return false
  }
  let classes = className.split(/\s+/)
  for (var i = 0; i < classes.length; i++) {
    if (classes[ i ] === name) {
      return true
    }
  }
  return false
}

const normaliseDate = function (date) {
  if (date) {
    date.setHours(0, 0, 0, 0)
  }
  return date
}

const addPeriods = function (date, amount, period) {
  if (period === 'd' || period === 'w') {
    normaliseDate(date)
    date.setDate(date.getDate() + amount * (period === 'w' ? 7 : 1))
  } else {
    var year = date.getFullYear() + (period === 'y' ? amount : 0)
    var month = date.getMonth() + (period === 'm' ? amount : 0)
    date.setTime(this._newDate(year, month + 1,
      Math.min(date.getDate(), this._daysInMonth(year, month + 1))).getTime())
  }
  return date
}
const clearHours = function (time) {
  let cloneDate = new Date(time)
  cloneDate.setHours(0, 0, 0, 0)
  return cloneDate.getTime()
}
export {
  hasClass,
  addPeriods,
  normaliseDate,
  clearHours
}



// WEBPACK FOOTER //
// ./src/components/date-picker/util.js